import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentMenuI: 0,
    aboutTabI: 0,
    newsTabI: 0
  },
  mutations: {
    setCurrentMenuI (state, i) {
      state.currentMenuI = i
    },
    setAboutTabI (state, i) {
      state.aboutTabI = i
    },
    setNewsTabI (state, i) {
      state.newsTabI = i
    }
  },
  actions: {
  },
  modules: {
  }
})
